/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type CmsCourseUpdateRequestStatus = typeof CmsCourseUpdateRequestStatus[keyof typeof CmsCourseUpdateRequestStatus];


export const CmsCourseUpdateRequestStatus = {
  UNKNOWN: 'UNKNOWN',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
} as const;
